import { ParamsAdapter } from '@ng-gems/api';

import { NotificationStatus } from '@models/types/notification-status';

export class NotificationMarkAsReadPatchParams extends ParamsAdapter {
  /**
   * @param status Status of the notification
   */
  constructor(private status: NotificationStatus) {
    super();
  }

  getParams(): unknown {
    const apiParams = {};
    apiParams['status'] = this.status;

    return apiParams;
  }
}
